// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-booksellerbillingregisterreport',
//   standalone: true,
//   imports: [],
//   templateUrl: './booksellerbillingregisterreport.component.html',
//   styleUrl: './booksellerbillingregisterreport.component.scss'
// })
// export class BooksellerbillingregisterreportComponent {

// }

import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';
import * as XLSX from 'xlsx';

@Component({
   selector: 'app-booksellerbillingregisterreport',
   templateUrl: './booksellerbillingregisterreport.component.html',
    styleUrl: './booksellerbillingregisterreport.component.scss'
})
export class BooksellerbillingregisterreportComponent implements OnInit {
  startDate;
  endDate;
  today;
  issueName;
  issueDates;
  reportType;
  advtInvoiceData;
  filteredAdvtInvoiceData: any;
    officeRepData: any[] = [];         // In Detail
  officeRepBriefData: any[] = [];    // Briefly
officeRepDetailData: any[] = [];
  isLoading = false;
  printShowData = [];
  filteredPrintShowData = [];
  sdate: any;
  enddate: any;
  invoiceNumber: any;
  issuedate: any;
  invoiceName: any;
  advtamount: any;
  discountamt: any;
  netamount: any;
  gstcst: any;
  totalinvoiceamount: any;
  paidamount: any;
  filteredAdvtInvoiceDatamonthly: any;
  netamountm: any;
  advtamountm: any;
  gstcstm: any;
  paidamountm: any;
 credit_note_amount: number;
  filteredAdvtInvoiceDatabrifly: any;
  beforegst: any;
  tcgst: any;
  tsgst: any;
  tigst: any;
  tgst: any;
  totalamount: any;
  cgst: number;
  sgst: number;
  igst: number;
  showData: any;
  receivedamt: number;
  pendingamt: number;
  totals: { first_week_amount: number; second_week_amount: number; third_week_amount: number; fourth_week_amount: number; fifth_week_amount: number; first_week_cgst: number; second_week_cgst: number; third_week_cgst: number; fourth_week_cgst: number; fifth_week_cgst: number; first_week_sgst: number; second_week_sgst: number; third_week_sgst: number; fourth_week_sgst: number; fifth_week_sgst: number; first_week_igst: number; second_week_igst: number; third_week_igst: number; fourth_week_igst: number; fifth_week_igst: number; pay_amt: number; issue_selling_discount_amt: number; net_amount: number; gst_amount: number; received_amt: number; total_invoice_amt: number; };
  dataList: any;
  beforegst1: number;
  tcgst1: number;
  tigst1: number;
  tsgst1: number;
  tgst1: number;
  discountamt1: number;
  receivedamt1: number;
  pendingamt1: number;
  totalamount1: number;
  netamount1: number;
  amount1: number;
  secondweek: number;
  thirdweek: number;
  fourthweek: number;
  fifthweek: number;
  firstweek: number;
  beforegst11: number;
  discountamt3: number;
  paidamount1: number;
  cgst4: number;
  igst4: number;
  sgst4: number;
  totalamount2: number;
  issueamt: number;
  filteredrniInvoiceDatabrifly: any;
  monthWiseRNIData: unknown[];
  grandW1: number;
  grandW3: number;
  grandW2: number;
  grandW4: number;
  grandW5: number;
  grandCopies: number;
  grandAmt: number;
  grandOpening: number;
  grandDisc: number;
  grandCW2: number;
  grandCW1: number;
  grandCW4: number;
  grandCW3: number;
  grandCW5: number;
  grandCCopies: number;
  total_invoice: number;
  total_crdtvamt: number;
  total_selecteamt: number;
  total_crdtnote_total: number;
  total_shipping: number;
  total_remaining: number;
total_cgst:number;
total_sgst:number;
total_igst:number;
total_gst:number;
// total_shipping:number;
total_amount = 0;
  invoice_total: number;
  selecteamt: number;
  crdtvamt: number;
  crdtnote_total:number;
  remaining_amt: number;
  totalRow: any;
  monthColumns: any;
  repwise: string;
  officerepwise: string;
// total_selecteamt:number;
// total_remaining:number;
// total_crdtvamt :number;
// total_crdtnote_total:number;


  constructor(
    private dialogRef: MatDialogRef<BooksellerbillingregisterreportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    debugger

    this.isLoading = false;
    // this.isloading
    this.today = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.issueName = this.data['issueName'];
    this.issueDates = this.data['issueDates'];
    this.reportType = this.data['reportType'];
    this.sdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    this.invoiceName = this.data['issueName'];
    this.issuedate = this.data['issueDates'];
      this.repwise = this.data?.rep_name || '';
  this.officerepwise = this.data?.office_rep_name || '';
    
    // this.advtInvoiceData = this.data['advtData'];
    // console.log(this.data);

    console.log(this.sdate, this.enddate, this.invoiceName, this.issuedate, "data");

    this.getData();
     if (this.reportType === 'office Rep In Detail') {
      this.getOfficeRepInDetail();
      return;
    }

    /* 🔴 OFFICE REP – BRIEFLY */
    if (this.reportType === 'Office Rep -Briefly') {
      this.getOfficeRepBriefly();
      return;
    }
       if (this.reportType === 'office Rep In Details') {
      this.getOfficeRepInDetails();
    }
  }


  getData() {
    debugger


    const req: any = {
      "start_date": this.sdate,
      "end_date": this.enddate,
      "issue_name": this.issueName,
      "issue_date": this.issueDates,
       rep_name: this.repwise || '',
  office_rep_name: this.officerepwise || ''

    }
   this.service.getBookInvoiceRegisterList(req).subscribe((res: any) => {
  console.log(res);

  this.filteredAdvtInvoiceData = res;

  // Reset totals
    this.total_invoice = 0;
  this.total_cgst = 0;
  this.total_sgst = 0;
  this.total_igst = 0;
  this.total_gst = 0;
  this.total_shipping = 0;
  this.total_amount = 0;
  this.total_selecteamt = 0;
  this.total_remaining = 0;
  this.total_crdtvamt = 0;
  this.total_crdtnote_total = 0;

  // Loop and calculate totals
  for (let row of this.filteredAdvtInvoiceData) {

    this.total_invoice += Number(row.invoice_total) || 0;
    this.total_cgst += Number(row.cgst) || 0;
    this.total_sgst += Number(row.sgst) || 0;
    this.total_igst += Number(row.igst) || 0;
    this.total_gst += Number(row.gst) || 0;

    this.total_shipping += Number(row.shipping_charges) || 0;
    this.total_amount += Number(row.amount) || 0;

    this.total_selecteamt += Number(row.selecteamt) || 0;
    this.total_remaining += Number(row.remaining_amt) || 0;

    this.total_crdtvamt += Number(row.crdtvamt) || 0;
    this.total_crdtnote_total += Number(row.crdtnote_total) || 0;
  }

  console.log("Totals Calculated");
});

    this.service.getbooksaleRegisterListmonthly(req).subscribe((res: any) => {
      console.log('API Response:', res);
      
      this.filteredAdvtInvoiceDatamonthly = res.data || [];
      this.totalRow = res.totals || {};
      this.monthColumns = res.months || [];
      
      console.log('Monthwise report data:', this.filteredAdvtInvoiceDatamonthly);
    });





    this.service.getbookInvoiceRegisterListbriefly(req).subscribe((res: any) => {
      console.log(res);
      this.filteredAdvtInvoiceDatabrifly = res;
      this.invoice_total = 0;
      this.selecteamt = 0;
      this.crdtnote_total = 0;
      this.remaining_amt = 0;
      for (let data1 of this.filteredAdvtInvoiceDatabrifly) {

        this.invoice_total += parseInt(data1.invoice_total) || 0;
        this.selecteamt += parseInt(data1.selecteamt) || 0;
        this.crdtnote_total += parseInt(data1.crdtnote_total) || 0;
        this.remaining_amt += parseInt(data1.remaining_amt) || 0;
      }
      console.log("inovice register data", this.filteredAdvtInvoiceDatabrifly)
    });


   this.service.getissueInvoiceRegisterListrni(req).subscribe((res: any) => {
  console.log(res);
  debugger;

  // Reset grand totals
  this.grandAmt = this.grandDisc = this.grandOpening = 0;
  this.grandW1 = this.grandW2 = this.grandW3 = this.grandW4 = this.grandW5 = 0;
  this.grandCopies = 0;
  this.grandCW1 = this.grandCW2 = this.grandCW3 = this.grandCW4 = this.grandCW5 = 0;
  this.grandCCopies = 0;

  // Group by Month
  const grouped: any = {};

  for (let data of res) {
    // ✅ Format month and year in Marathi
    const monthName = new Date(data.invoice_date).toLocaleString('mr-IN', {
      month: 'long',
      year: 'numeric'
    });

    if (!grouped[monthName]) {
      grouped[monthName] = {
        monthName,
        invoices: [],
        totalW1: 0,
        totalW2: 0,
        totalW3: 0,
        totalW4: 0,
        totalW5: 0,
        totalCW1: 0,
        totalCW2: 0,
        totalCW3: 0,
        totalCW4: 0,
        totalCW5: 0,
        totalCCopies: 0, // ✅ Added this initialization
        totalCopies: 0,
        totalAmt: 0,
        totalDisc: 0,
        totalOpening: 0
      };
    }

    // Push invoice into month
    grouped[monthName].invoices.push(data);

    // Update month totals
    grouped[monthName].totalW1 += +data.week1_copies || 0;
    grouped[monthName].totalW2 += +data.week2_copies || 0;
    grouped[monthName].totalW3 += +data.week3_copies || 0;
    grouped[monthName].totalW4 += +data.week4_copies || 0;
    grouped[monthName].totalW5 += +data.week5_copies || 0;
    grouped[monthName].totalCopies += +data.total_week_copies || 0;

    grouped[monthName].totalCW1 += +data.week1_com_copies || 0;
    grouped[monthName].totalCW2 += +data.week2_com_copies || 0;
    grouped[monthName].totalCW3 += +data.week3_com_copies || 0;
    grouped[monthName].totalCW4 += +data.week4_com_copies || 0;
    grouped[monthName].totalCW5 += +data.week5_com_copies || 0;
    grouped[monthName].totalCCopies += +data.total_week_com_copies || 0;

    grouped[monthName].totalAmt += +data.total_amount || 0;
    grouped[monthName].totalDisc += +data.total_discount || 0;
    grouped[monthName].totalOpening += +data.opening_bal || 0;

    // Update grand totals
    this.grandW1 += +data.week1_copies || 0;
    this.grandW2 += +data.week2_copies || 0;
    this.grandW3 += +data.week3_copies || 0;
    this.grandW4 += +data.week4_copies || 0;
    this.grandW5 += +data.week5_copies || 0;
    this.grandCopies += +data.total_week_copies || 0;

    this.grandCW1 += +data.week1_com_copies || 0;
    this.grandCW2 += +data.week2_com_copies || 0;
    this.grandCW3 += +data.week3_com_copies || 0;
    this.grandCW4 += +data.week4_com_copies || 0;
    this.grandCW5 += +data.week5_com_copies || 0;
    this.grandCCopies += +data.total_week_com_copies || 0; // ✅ Correct accumulation

    this.grandAmt += +data.total_amount || 0;
    this.grandDisc += +data.total_discount || 0;
    this.grandOpening += +data.opening_bal || 0;
  }

  // Convert grouped data to array for *ngFor
  this.monthWiseRNIData = Object.values(grouped);

  console.log("Month-wise RNI Report Data", this.monthWiseRNIData);
});



  }
   getOfficeRepInDetail(): void {

  this.isLoading = true;

  const req = {
    start_date: this.startDate,
    end_date: this.endDate,
    rep_name: this.repwise || '',
  office_rep_name: this.officerepwise || ''
  };

  this.service.getbookInvoiceRegisterListbriefly1(req).subscribe({
    next: (res: any[]) => {

      this.officeRepData = res || [];

      // 🔁 RESET GRAND TOTAL
        this.grandTotal = {
        invoice_amount: 0,
        receipt_amount: 0,
       credit_note_amount: 0,
        pending_amount: 0,
        // credit_note_amount:0,
      };

      // 🔢 CALCULATE GRAND TOTAL
      this.officeRepData.forEach((office: any) => {
        if (office.office_totals) {
          this.grandTotal.invoice_amount += +office.office_totals.invoice_amount || 0;
          this.grandTotal.receipt_amount += +office.office_totals.receipt_amount || 0;
          this.grandTotal.credit_note_amount += +office.office_totals.credit_note_amount || 0;
          this.grandTotal.pending_amount += +office.office_totals.pending_amount || 0;
        }
      });

      this.isLoading = false;
    },
    error: () => {
      this.officeRepData = [];
      this.isLoading = false;
    }
  });
}

getOfficeRepInDetails(): void {

  const req = {
    start_date: this.startDate,
    end_date: this.endDate,
    rep_name: this.repwise || '',
  office_rep_name: this.officerepwise || ''
  };

  this.service.getOfficeRepInDetailsReport(req).subscribe({
    next: (res: any[]) => {

      this.officeRepDetailData = res || [];

      this.grandTotal = {
        invoice_amount: 0,
        receipt_amount: 0,
        credit_note_amount: 0,
        pending_amount: 0
      };

      this.officeRepDetailData.forEach((office: any) => {
        this.grandTotal.invoice_amount += office.office_totals.invoice_amount;
        this.grandTotal.receipt_amount += office.office_totals.receipt_amount;
        this.grandTotal.credit_note_amount += office.office_totals.crdtnote_total;
        this.grandTotal.pending_amount += office.office_totals.pending_amount;
      });
    },
    error: () => {
      this.officeRepDetailData = [];
    }
  });
}


getOfficeRepBriefly(): void {

  const req = {
    start_date: this.startDate,
    end_date: this.endDate,
    rep_name: this.repwise || '',
  office_rep_name: this.officerepwise || ''
  };

  this.service.getOfficeRepBrieflyReport(req).subscribe({
    next: (res: any) => {

      // ================= TABLE DATA =================
      this.officeRepBriefData = res?.data ?? [];

      // ================= GRAND TOTAL MAPPING =================
      this.grandTotal = {
        invoice_amount: Number(res?.grand_total?.total_invoice_amount ?? 0),
        receipt_amount: Number(res?.grand_total?.paid_amount ?? 0),

        // ✅ FIXED: correct key from API
        credit_note_amount: Number(res?.grand_total?.crdtnote_total ?? 0),

        pending_amount: Number(res?.grand_total?.unpaid_amount ?? 0)
      };
    },

    error: (err) => {
      console.error('Office Rep Briefly API Error:', err);

      this.officeRepBriefData = [];

      // ================= RESET GRAND TOTAL =================
      this.grandTotal = {
        invoice_amount: 0,
        receipt_amount: 0,
        credit_note_amount: 0,
        pending_amount: 0
      };
    }
  });
}

grandTotal = {
  invoice_amount: 0,
  receipt_amount: 0,
  pending_amount: 0,
 credit_note_amount:0
};

getMonthValue(data: any, month: string): number {
    return data.months && data.months[month] ? data.months[month] : 0;
  }

  // Helper method to calculate grand total
  calculateGrandTotal(): number {
    return this.totalRow.grand_total || 0;
  }

  filterData() {
    // console.log('called');
    if (this.startDate == '' && this.endDate == '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData;
      // console.log('filteredData', this.advtInvoiceData);
    } else if (this.startDate !== '' && this.endDate !== '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData.filter((a) => {
        return (
          a['invoice_date'] >= this.startDate &&
          a['invoice_date'] <= this.endDate
        );
      });
      // console.log('filteredData', this.advtInvoiceData);
    }

    setTimeout(() => {
      this.setData();
    }, 700);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  setData() {
    // console.log(this.advtInvoiceData);
    // console.log(this.advtInvoiceData);
    if (this.advtInvoiceData.length == 0) {
      this.isLoading = false;
      alert('Data is not Present.');
      this.dialogRef.close();
    }
    let data = this.uniqueid(this.advtInvoiceData, (a) => a.advt_name);
    // console.log(data);
    for (let index = 0; index < this.advtInvoiceData.length; index++) {
      // let eachData = this.advtInvoiceData.filter(
      //   (a) => data[i]['advt_name'] == a.advt_name
      // );

      let showData = {
        issue_name: '',
        invoice_no: '',
        invoice_date: '',
        advt_name: '',
        client_name: '',
        rep_name: '',
        off_rep_name: '',
        firstweek_issue_date: '',
        secondweek_issue_date: '',
        thirdweek_issue_date: '',
        fourthweek_issue_date: '',
        fifthweek_issue_date: '',
        total_advt_amt: 0,
        total_dis: 0,
        total_net: 0,
        total_cgst: 0,
        total_sgst: 0,
        total_igst: 0,
        total_amt: 0,
        total: 0,
      };

      // if (Object.keys(eachData).length > 0) {
      console.log('called', this.advtInvoiceData);
      // for (let index = 0; index < this.advtInvoiceData.length; index++) {
      if (
        this.advtInvoiceData[index]['first_week_id'] != null &&
        this.advtInvoiceData[index]['first_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['first_week_issue_date']
        )
      ) {
        // console.log('first');
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        console.log(showData['issue_name'], "new issue name");

        showData['firstweek_issue_date'] =
          this.advtInvoiceData[index]['first_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['first_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['first_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['second_week_id'] != null &&
        this.advtInvoiceData[index]['second_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['second_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['secondweek_issue_date'] =
          this.advtInvoiceData[index]['second_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['second_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['second_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['third_week_id'] != null &&
        this.advtInvoiceData[index]['third_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['third_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['thirdweek_issue_date'] =
          this.advtInvoiceData[index]['third_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['third_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['third_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fourth_week_id'] != null &&
        this.advtInvoiceData[index]['fourth_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['fourth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fourthweek_issue_date'] =
          this.advtInvoiceData[index]['fourth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fifth_week_id'] != null &&
        this.advtInvoiceData[index]['fifth_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['fifth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fifthweek_issue_date'] =
          this.advtInvoiceData[index]['fifth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_total_amount']
        );
      }
      // }
      if (
        (this.advtInvoiceData[index]['first_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['first_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['second_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['second_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['third_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['third_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fourth_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fourth_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fifth_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fifth_week_issue_date']
          ))
      ) {
        showData['invoice_no'] = this.advtInvoiceData[0]['invoice_no'];
        showData['invoice_date'] = this.advtInvoiceData[0]['invoice_date'];
        showData['advt_name'] = this.advtInvoiceData[0]['advt_name'];
        showData['client_name'] = this.advtInvoiceData[0]['cust_name'];
        showData['rep_name'] = this.advtInvoiceData[0]['rep_name'];
        showData['off_rep_name'] = this.advtInvoiceData[0]['off_rep_name'];

        this.printShowData.push(showData);
      }

      // console.log('showData', showData);
      // }
      console.log('printShowData', this.printShowData);
      if (index == data.length - 1) {
        this.isLoading = false;
        this.filterPrintShowData();
      }
    }
  }
  calculateTotals() {
    this.totals = {
      first_week_amount: 0,
      second_week_amount: 0,
      third_week_amount: 0,
      fourth_week_amount: 0,
      fifth_week_amount: 0,
      first_week_cgst: 0,
      second_week_cgst: 0,
      third_week_cgst: 0,
      fourth_week_cgst: 0,
      fifth_week_cgst: 0,
      first_week_sgst: 0,
      second_week_sgst: 0,
      third_week_sgst: 0,
      fourth_week_sgst: 0,
      fifth_week_sgst: 0,
      first_week_igst: 0,
      second_week_igst: 0,
      third_week_igst: 0,
      fourth_week_igst: 0,
      fifth_week_igst: 0,
      pay_amt: 0,
      issue_selling_discount_amt: 0,
      net_amount: 0,
      gst_amount: 0,
      received_amt: 0,
      total_invoice_amt: 0,
    };

    for (const data of this.dataList) {
      this.totals.first_week_amount += +(data.first_week_amount || 0);
      this.totals.second_week_amount += +(data.second_week_amount || 0);
      this.totals.third_week_amount += +(data.third_week_amount || 0);
      this.totals.fourth_week_amount += +(data.fourth_week_amount || 0);
      this.totals.fifth_week_amount += +(data.fifth_week_amount || 0);

      this.totals.first_week_cgst += +(data.first_week_cgst || 0);
      this.totals.second_week_cgst += +(data.second_week_cgst || 0);
      this.totals.third_week_cgst += +(data.third_week_cgst || 0);
      this.totals.fourth_week_cgst += +(data.fourth_week_cgst || 0);
      this.totals.fifth_week_cgst += +(data.fifth_week_cgst || 0);

      this.totals.first_week_sgst += +(data.first_week_sgst || 0);
      this.totals.second_week_sgst += +(data.second_week_sgst || 0);
      this.totals.third_week_sgst += +(data.third_week_sgst || 0);
      this.totals.fourth_week_sgst += +(data.fourth_week_sgst || 0);
      this.totals.fifth_week_sgst += +(data.fifth_week_sgst || 0);

      this.totals.first_week_igst += +(data.first_week_igst || 0);
      this.totals.second_week_igst += +(data.second_week_igst || 0);
      this.totals.third_week_igst += +(data.third_week_igst || 0);
      this.totals.fourth_week_igst += +(data.fourth_week_igst || 0);
      this.totals.fifth_week_igst += +(data.fifth_week_igst || 0);

      this.totals.pay_amt += +(data.pay_amt || 0);
      this.totals.issue_selling_discount_amt += +(data.issue_selling_discount_amt || 0);
      this.totals.net_amount += +(data.net_amount || 0);
      this.totals.gst_amount += +(data.gst_amount || 0);
      this.totals.received_amt += +(data.received_amt || 0);
      this.totals.total_invoice_amt += +(data.total_invoice_amt || 0);
    }
  }

  filterPrintShowData() {
    let data = this.uniqueid(this.printShowData, (a) =>
      formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530')
    );
    // console.log(data);
    let totalAdvtAmt1 = 0;
    let totalDisAmt1 = 0;
    let totalNetAmt1 = 0;
    let totalCGST1 = 0;
    let totalSGST1 = 0;
    let totalIGST1 = 0;
    let totalInvoiceAmount1 = 0;
    for (let index = 0; index < data.length; index++) {
      let filteredData = this.printShowData.filter((a) => {
        return (
          formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530') ==
          formatDate(data[index]['invoice_date'], 'MM', 'en-IN', 'GMT+0530')
        );
      });
      // console.log(filteredData);
      let totalAdvtAmt = 0;
      let totalDisAmt = 0;
      let totalNetAmt = 0;
      let totalCGST = 0;
      let totalSGST = 0;
      let totalIGST = 0;
      let totalInvoiceAmount = 0;
      let issue_date = '';
      for (let i = 0; i < filteredData.length; i++) {
        totalAdvtAmt += parseInt(filteredData[index]['total_advt_amt']);
        totalDisAmt += parseInt(filteredData[index]['total_dis']);
        totalNetAmt += parseInt(filteredData[index]['total_net']);
        totalCGST += parseInt(filteredData[index]['total_cgst']);
        totalSGST += parseInt(filteredData[index]['total_sgst']);
        totalIGST += parseInt(filteredData[index]['total_igst']);
        totalInvoiceAmount += parseInt(filteredData[index]['total_amt']);
        issue_date = filteredData[index]['invoice_date'];
      }

      filteredData.push({
        issue_date,
        totalAdvtAmt,
        totalDisAmt,
        totalNetAmt,
        totalCGST,
        totalSGST,
        totalIGST,
        totalInvoiceAmount,
      });

      totalAdvtAmt1 += totalAdvtAmt;
      totalDisAmt1 += totalDisAmt;
      totalNetAmt1 += totalNetAmt;
      totalCGST1 += totalCGST;
      totalSGST1 += totalSGST;
      totalIGST1 += totalIGST;
      totalInvoiceAmount1 = totalInvoiceAmount;

      this.filteredPrintShowData.push(filteredData);
    }

    this.filteredPrintShowData.push({
      totalAdvtAmt1,
      totalDisAmt1,
      totalNetAmt1,
      totalCGST1,
      totalSGST1,
      totalIGST1,
      totalInvoiceAmount1,
    });

    console.log(this.filteredPrintShowData);
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-sectionBILL');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');


    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }



  issuedatereturn(dates) {
    if (dates != null) {
      let returnissuedate = dates.split(',');
      return returnissuedate[0];
    } else {
      return null;
    }

  }
  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title

    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 10mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(style); // Add style to the document

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();

      document.title = ''; // Restore original title after printing

      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }


printPageA4(): void {
  const printContent = document.getElementById('print-sectionBILL');
  if (!printContent) {
    return;
  }

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Office Rep In Details Report</title>

        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          .office-total {
            background: #f9a14a !important;
            font-weight: bold;
          }

          .grand-total {
            background: #f6c28b !important;
            font-weight: bold;
          }

          @media print {
            .noPrint {
              display: none !important;
            }
          }
        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}
printPage4(): void {
  const printContents = document.getElementById('print-sectionBILL')?.innerHTML;
  if (!printContents) return;

  const popupWin = window.open('', '_blank', 'width=1400,height=900');

  popupWin!.document.open();
  popupWin!.document.write(`
    <html>
      <head>
        <title>.</title>

        <style>
          @page {
            size: A3 landscape;
            margin: 10mm;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            margin: 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
            font-size: 12px;
          }

          th {
            font-weight: bold;
          }

          .office-row td,
          .rep-row td {
            background: #eeeeee;
          }

          .office-total td {
            background: #f6c28b;
            font-weight: bold;
          }

          .rep-total td {
            background: #f1f1f1;
            font-weight: bold;
          }
 .total-row td {
            background-color: #f9a14a !important;
            font-weight: bold;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }



          .noPrint {
            display: none !important;
          }

          tr {
            page-break-inside: avoid;
          }
        </style>

      </head>
      <body onload="window.print(); window.close();">
        ${printContents}
      </body>
    </html>
  `);

  popupWin!.document.close();
}




printPage() {

  const printContent = document.getElementById('print-sectionBILL');

  const printWindow = window.open('', '', 'width=1400,height=900');

  if (!printWindow || !printContent) return;

  printWindow.document.write(`
  <html>
    <head>
      <title>.</title>

      <style>

        /* FORCE COLOR PRINT */
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        @page {
          size: A4 landscape;
          margin: 10mm;
        }

        body {
          font-family: Arial, sans-serif;
          font-size: 12px;
          color: #000;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        thead {
          display: table-header-group;
        }

        tr {
          page-break-inside: avoid;
        }

        .print-header {
          table-layout: fixed;
        }

        .print-header th {
          font-size: 16px;
          font-weight: bold;
          padding: 6px 8px;
        }

        .h-left { width: 30%; text-align: left; }
        .h-center { width: 40%; text-align: center; }
        .h-right { width: 30%; text-align: right; }

        .nowrap { white-space: nowrap; }

        /* TOTAL ROW COLOR */
        @media print {

          .total-row td {
            background-color: #f9a14a !important;
            font-weight: bold;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

        }

      </style>
    </head>

    <body onload="window.print(); window.close();">
      ${printContent.innerHTML}
    </body>
  </html>
  `);

  printWindow.document.close();
}




printPage1() {
  const printContent = document.getElementById('print-sectionBILL');

  const printWindow = window.open('', '', 'width=1400,height=900');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>.</title>

        <style>
          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          /* FORCE BACKGROUND COLORS */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
          }

          .noPrint {
            display: none !important;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
            font-size: 12px;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* OFFICE / REP ROWS */
          .office-row td {
           
            font-weight: bold;
            text-align: center;
          }

          .rep-row td {
           
            font-weight: bold;
          }

          .rep-total td {
           
            font-weight: bold;
          }

          .office-total td {
            background-color: #f6c28b;
            font-weight: bold;
          }

          .grand-total td {
            background-color: #f9a14a;
            font-weight: bold;
            font-size: 14px;
          }
        </style>
      </head>

      <body onload="window.print(); window.close();">
        ${printContent!.innerHTML}
      </body>
    </html>
  `);

  printWindow!.document.close();
}








printPageA41() {

  const printContent = document.getElementById('print-sectionBILL');
  if (!printContent) {
    return;
  }

  const printWindow = window.open('', '', 'width=900,height=1200');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>.</title>

        <style>
          /* ===== PAGE SETUP ===== */
          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;

            /* IMPORTANT: allow background colors */
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          /* Hide buttons */
          .noPrint {
            display: none !important;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
            font-size: 12px;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== HEADER ===== */
          th {
            font-weight: bold;
            text-align: center;
          }

          /* ===== ROW COLORS ===== */
          .office-row td {
            background: #eeeeee;
            font-weight: bold;
            text-align: center;
          }

          .rep-row td {
            background: #f5f5f5;
            font-weight: bold;
          }

          .office-total td {
            background: #f6c28b;
            font-weight: bold;
          }

          .grand-total td {
            background: #f9a14a;
            font-weight: bold;
            font-size: 13px;
          }
        </style>
      </head>

      <body onload="window.print(); window.close();">
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  printWindow!.document.close();
}










}
function printPage() {
  throw new Error('Function not implemented.');

}




